import React from "react";
import ToggleButton from "../../../shared/components/ToggleButton";
import { Chevron } from "../../../shared/svg";
import { chevronDirection } from "../../svg/Svg";

function Pagination({ page, updateFilter, canNextPage }) {
  const isHidden = page === 0 && !canNextPage;

  return (
    <div style={isHidden ? { display: 'none' } : {}} className="mls-o-pagination">
      <ToggleButton
        className={'mls-o-buttons__slideshow mls-o-buttons__slideshow--no-outline'}
        onClick={() => updateFilter(page - 1)}
        disabled={page === 0}
        aria-label="Previous results">
        <Chevron direction={chevronDirection.left}/>
      </ToggleButton>

      <span tabIndex="0" className={"mls-o-pagination__page"}>
              {`Page ${page + 1}`}
            </span>

      <ToggleButton
        className={'mls-o-buttons__slideshow mls-o-buttons__slideshow--no-outline'}
        onClick={() => updateFilter(page + 1)}
        disabled={!canNextPage}
        aria-label="Next results">
        <Chevron direction={chevronDirection.right}/>
      </ToggleButton>
    </div>
  );
};

// eslint-disable-next-line no-func-assign
Pagination = React.memo(Pagination);

export default Pagination;
